import { EListingModalActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setActiveOfferId = actionGenerator<EListingModalActionType.SetActiveOfferId, number | null>(
  EListingModalActionType.SetActiveOfferId,
);
